export default "__VITE_ASSET__p79JbLcr__"